import { useMutation } from "react-query";
import api from "../../client";
import { CreateInteractionPayload, Interaction } from "../../types/interaction";

const postData = async (
  payload: CreateInteractionPayload,
): Promise<Interaction> => {
  const { data } = await api.post(`/interactions`, payload);

  return data;
};

export const useCreateInteraction = () => {
  return useMutation((payload: CreateInteractionPayload) => {
    return postData(payload);
  });
};
